import React from 'react';
import loading from '../../assets/loading.gif';
import './loader.css';

const Loader = () => {
    return (
        <div className="loader-bg">
            <div className='loader'>
                <img src={loading} alt='loading-img'/>
            </div>
        </div>
    );
};

export default Loader;